import React, { FunctionComponent, useState } from 'react';
import { Box, Link, Typography } from '@material-ui/core';
import servicePlanItemStyles from './ServicePlanItemStyles';
import clsx from 'clsx';
import Price from '../../../../../../common/components/presentation/Price';
import usePlatformConfig from '../../../../../../common/react/usePlatformConfig';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Checkbox from '@material-ui/core/Checkbox';
import dealPriceAccessor from '../../../../../../common/service/dealPriceAccessor';
import { IPrices } from '../../../../../../../../common/model/IPrice';
import { IServiceInterval } from '../../../../../model/IServicePlan';
import ServicePlanItemDetails from '../servicePlanItemDetails/ServicePlanItemDetails';
import Collapse from '@material-ui/core/Collapse';
import Translation from '../../../../../../common/components/translation/Translation';

export interface IServicePlanItemProps {
  name: string;
  prices: IPrices;
  selected: boolean;
  serviceIntervals: IServiceInterval[];
  onClick: (servicePlanId: string) => void;
  servicePlanId: string;
}

const ServicePlanItem: FunctionComponent<IServicePlanItemProps> = ({
  selected,
  name,
  prices,
  onClick,
  serviceIntervals,
  servicePlanId,
}) => {
  const styles = servicePlanItemStyles();
  const {
    platformConfig: { priceDisplay },
  } = usePlatformConfig();
  const [priceGuideOpen, setPriceGuideOpen] = useState(false);
  const primaryPrice = dealPriceAccessor.getPrimaryPrice(prices, priceDisplay);

  return (
    <Box
      className={clsx([styles.container, { [styles.planSelected]: selected }])}
      data-test={`customise:servicePlan:${servicePlanId}`}
    >
      <Box display="flex" alignItems="flex-start">
        <Checkbox
          data-test="customise:servicePlanToggle"
          className={styles.servicePlanCheckbox}
          checked={selected}
          onChange={() => onClick(servicePlanId)}
        />
        <Box className={styles.titlePriceContainer}>
          <Box>
            <Typography data-test="customise:servicePlanName">{name}</Typography>
            <Price
              data-test="customise:servicePlanPrice"
              className={styles.mobilePriceValue}
              price={primaryPrice?.basePrice}
              currency={priceDisplay.primaryOptions.currency}
              decimals={priceDisplay.primaryOptions.decimalScale}
            />
            <Link
              className={styles.priceGuideToggle}
              onClick={() => setPriceGuideOpen(!priceGuideOpen)}
              data-test="customise:servicePlanPriceGuide"
            >
              <Translation id="spc.customise.serviceSection.priceGuide" />
              <ExpandMoreIcon className={clsx([styles.expandIcon, { [styles.invertedIcon]: priceGuideOpen }])} />
            </Link>
          </Box>
          <Price
            data-test="customise:servicePlanPrice"
            className={styles.priceValue}
            price={primaryPrice?.basePrice}
            currency={priceDisplay.primaryOptions.currency}
            decimals={priceDisplay.primaryOptions.decimalScale}
          />
        </Box>
      </Box>
      {
        <Collapse in={priceGuideOpen}>
          <ServicePlanItemDetails serviceIntervals={serviceIntervals} totalBasePrice={primaryPrice?.basePrice} />
        </Collapse>
      }
    </Box>
  );
};

export default ServicePlanItem;
